module.exports = __webpack_public_path__ + "client/img/sever-rocess.ea4b165c.png";